-<template>
  <!-- 5-2 医疗机构查看教育机构信息页面 -->
  <div class="main-css">
    <div class="main-box-css-all">
      <div class="main-box">
        <!-- 左边查看信息部分 -->
        <div class="left-box">
          <!-- 主要显示box 滚动条隐藏部分 -->
          <div class="left-main-box">
            <!-- 第一行 -->
            <div class="one-line-box">
              <div class="avt-img">
                <img :src="getUrlList" alt="" />
              </div>
              <div class="big-form-box">
                <span>{{ $t("institutionName") }}</span>
                <p class="institution-main">{{ schoolDetailsList.educationName }}</p>
                <!-- 认证部分 -->
                <div class="certified">{{ $t("certified") }}</div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("postCode") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.postNumber }}</p>
              </div>
              <div class="big-box">
                <span>{{ $t("location") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.address }}</p>
              </div>
            </div>
            <!-- 第三行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("institutionalAttributes") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.attributes }}</p>
              </div>
              <div class="big-box">
                <span>HP or SNS</span>
                <p class="small-box-title">{{ schoolDetailsList.hpOrSns }}</p>
              </div>
            </div>
            <!-- 第四行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("representativeName") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.legalPerson }}</p>
              </div>
              <div class="big-box">
                <span>{{ $t("institutionalNumber") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.telephone }}</p>
              </div>
            </div>
            <!-- 第五行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("numberOfEmployees") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.teacherNumber }}</p>
              </div>
              <div class="big-box" style="margin-right: 12px">
                <span>{{ $t("studentNumber") }}</span>
                <p class="small-box-title">{{ schoolDetailsList.studentNumber }}</p>
              </div>
            </div>
            <!-- 第六行 -->
            <div class="textarea-line-box">
              <div class="textarea-box">
                <span>{{ $t("businessContent") }}</span>
                <p class="textarea-css-main">{{ schoolDetailsList.introduction }}</p>
              </div>
            </div>
            <!-- table 部分 -->
            <div class="table-line">
              <el-table :data="tableData" style="width: 100%" height="500px">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="name" label="学生氏名" width="120">
                  <template slot="header">
                    <p>{{ $t("studentName") }}</p>
                    <el-input
                      v-model="tableSearch1"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template  slot-scope="scope">
                    {{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column prop="sex" label="性別" width="100">
                  <template slot="header">
                    <p>{{ $t("sex") }}</p>
                    <el-input
                      v-model="tableSearch2"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template  slot-scope="scope">
                    <span v-if="language === 'ja-JP'">{{ scope.row.jpsex_dictText }}</span>
                    <span v-else>{{ scope.row.sex_dictText }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="birth" label="生年月日" width="100">
                  <template slot="header">
                    <p>{{ $t("birth") }}</p>
                    <el-input
                      v-model="tableSearch3"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="education" label="学歴">
                  <template slot="header">
                    <p>{{ $t("education") }}</p>
                    <el-input
                      v-model="tableSearch4"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="profession" label="専攻" width="120">
                  <template slot="header">
                    <p>{{ $t("major") }}</p>
                    <el-input
                      v-model="tableSearch5"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="japanese" label="日本語">
                  <template slot="header">
                    <p>{{ $t("japanese") }}</p>
                    <el-input
                      v-model="tableSearch6"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页部分 -->
              <div class="pagination">
                <div class="el-pagination">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout=" prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    small
                  >
                  </el-pagination>
                </div>
                <div class="rowsPage">
                  <span>Rows per page</span>
                  <div class="rowsPage-css">
                    <el-dropdown @command="handleCommand">
                      <span class="el-dropdown-link">
                        {{ pageSize }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">5</el-dropdown-item>
                        <el-dropdown-item command="b">10</el-dropdown-item>
                        <el-dropdown-item command="c">15</el-dropdown-item>
                        <el-dropdown-item command="d">20</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边聊天部分 -->
        <div class="right-box">
          <Socket></Socket>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="main-button">
        <button @click="collect">{{ $t("collection") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Socket from "../../components/socket.vue";
  import {
    educationResumeInfoQuery,
    educationalInstitutionDisplay,
    educationDetailQuery,
    schoolDetailsQuery,
    insertMedicalCollection,
    getUrlFromOSS
  } from "../../js/api";
  import AES from "../../js/AES";
  export default {
    name: "medicalViewEducationHomepage",
    components: { Socket },
    data() {
      return {
        //列表数据
        tableData: [],
        loading: false,
        educationId:"",
        educationName: "", //左边機関名
        agencyAttribute: "", //左边機関属性
        hPorSNS: "", //左边HP or SNS
        representativeName: "", //左边代表者氏名
        phoneNumber: "", //左边機関の電話番号
        teacherNumber: "", //左边授業員数
        studentNumber: "", //左边学生人数
        introduction: "", //左边事業内容
        tableSearch1: "", //table学生氏名
        tableSearch2: "", //table性別
        tableSearch3: "", //table生年月日
        tableSearch4: "", //table学歴
        tableSearch5: "", //table専攻
        tableSearch6: "", //table日本語
        currentPage: 1, //页数
        pageSize: 5, //每页条数
        schoolDetailsList:[],
        total:"",
        imgUrl:"",
        language:""
      };
    },
    created() {
      this.language=this.$i18n.locale;
      this.educationId="02168da1d6c511ecbac800ffd1723a85"
      this.getList()
    },
    computed: {},
    methods: {
      //图片回显
      getUrlList(url){
        console.log("url"+url);
        var fakeInfo={
          message: url
        }
        getUrlFromOSS(fakeInfo).then((res) => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.imgUrl=aesFecInfo.message;
          }else{
            console.log(res);
          }
        }).catch(() => {
        })
      },
      //接口 获取表格数据
      getList(){
        //左侧数据获取
        var fakeInfo = {
          educationId: this.educationId,
        };
        educationDetailQuery(fakeInfo)
          .then((res) => {
            console.log("--------管理员查询教育机构详细信息接口--------");
            console.log(res);
            if (res.data.code === "A0000") {
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
              console.log(aesFecInfo)
              this.schoolDetailsList = aesFecInfo[0];
              this.institutionName = aesFecInfo[0].educationName     //機関名
              this.postCode = aesFecInfo[0].postNumber             //郵便番号
              this.area = aesFecInfo[0].address                    //所在地
              this.agencyAttribute = aesFecInfo[0].attributes      //機関属性
              this.hPorSNS = aesFecInfo[0].hpOrSns                 //HP or SNS
              this.representativeName = aesFecInfo[0].legalPerson  //代表者氏名
              this.phoneNumber = aesFecInfo[0].telephone           //機関の電話番号
              this.numberEmployees = aesFecInfo[0].teacherNumber   //授業員数
              this.studentNumber = aesFecInfo[0].studentNumber     //学生人数
              this.textData = aesFecInfo[0].introduction           //事業内容
              console.log("qaq"+schoolDetailsList.avatarAddress);
              this.getUrlList(aesFecInfo[0].avatarAddress);
              console.log("链接成功");
            } else {
              this.$message.error('登录失败。');
            }
          })
          .catch((res) => {});
        //右侧数据获取
        var fakeInfo2 = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
        };
        educationResumeInfoQuery(fakeInfo2)
          .then((res2) => {
            console.log("--------学生信息获取--------");
            console.log(res2);
            if (res2.data.code === "A0000") {
              const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data))
              console.log("输出")
              console.log(aesFecInfo2)
              this.tableData = aesFecInfo2.data;
              this.total=aesFecInfo2.total;
              console.log(aesFecInfo2.total);
              console.log(this.tableData);
              console.log("链接成功");
            } else {
              this.$message.error('登录失败。');
            }
          })
          .catch((res) => {});
      },
      change(e) {
        this.$forceUpdate();
      },
      //每页条数下拉框
      handleCommand(command) {
        if (command === "a") {
          this.pageSize = 5;
        } else if (command === "b") {
          this.pageSize = 10;
        } else if (command === "c") {
          this.pageSize = 15;
        } else if (command === "d") {
          this.pageSize = 20;
        }
        this.currentPage = 1;
        this.getList();
      },
      // 分页页数变化
      handleCurrentChange(evt) {
        this.currentPage = evt;
        this.getList();
      },
      jump(row,event,column){
        this.$router.push({
          path: '/medicalInstitutionTalentInformationViewPublic',
          name: 'medicalInstitutionTalentInformationViewPublic',
          params: {
            resumeId: row.resumeId,
          }
        });
      },
      collect(){
        var fakeInfo = {
          systemEventId: this.educationId,
          systemTypeId: 1,
        }
        insertMedicalCollection(fakeInfo).then((res) => {
          console.log("医疗机构新增收藏接口", res)
          if(res.data.code === "A0000"){
            this.$message({
              message: '收藏成功！',
              type: 'success'
            });
            this.$router.push({
              path: '/medicalFavouritesEducationalInstitutionsViewList',
              name: 'medicalFavouritesEducationalInstitutionsViewList',
              params: {
              }
            });
          } else if (res.data.code === "A0506"){
            this.$message({
              message: '该机构已被收藏！',
              type: 'warning'
            });
          } else {
            this.$message.error('提交错误！');
          }
        }).catch((res) => {
          console.log("医疗机构新增收藏接口异常", res)
        })

      },
    },
  };
</script>
<style scoped>
  .main-css {
    width: 100%;
    height: 100%;
    background: #fff;
  }
  .main-box {
    display: flex;
  }
  .main-box-css-all {
    width: 1200px;
    margin: 0 auto;
  }
  .left-box {
    width: 550px;
    height: 650px;
    margin: 40px 50px 0 0px;
    overflow: hidden;
  }
  .left-main-box {
    width: 567px;
    height: 650px;
    overflow-y: scroll;
    padding-right: 17px;
    box-sizing: border-box;
  }
  .one-line-box {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
  }
  .avt-img {
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 50%;
  }
  .big-form-box {
    height: 57px;
    width: 299px;
    border-radius: 8px;
    background: #ffffff;
    border: 2px solid #51abff;
    box-sizing: border-box;
    margin-left: 30px;
    margin-top: 50px;
    position: relative;
  }
  .certified {
    width: 49px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    background: #fc630c;
    border-radius: 4px;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    letter-spacing: -0.02em;
    color: #ffffff;
    position: absolute;
    right: 0;
    top: -22px;
  }
  .big-form-box span {
    height: 24px;
    line-height: 24px;
    background: #fff;
    padding: 0 5px;
    position: absolute;
    top: -12px;
    left: 15px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
  }
  .other-line-box {
    width: 100%;
    height: 45px;
    margin-top: 24px;
    display: flex;
  }
  .small-box {
    width: 200px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #b2b2b2;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    margin-right: 10px;
  }
  .small-box span {
    height: 24px;
    line-height: 24px;
    background: #fff;
    padding: 0 5px;
    position: absolute;
    top: -12px;
    left: 15px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
  }
  .big-box {
    width: 292px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #b2b2b2;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }
  .big-box span {
    height: 24px;
    line-height: 24px;
    background: #fff;
    padding: 0 5px;
    position: absolute;
    top: -12px;
    left: 15px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
  }
  .most-small-box {
    width: 140px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #b2b2b2;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }
  .most-small-box span {
    height: 24px;
    line-height: 24px;
    background: #fff;
    padding: 0 5px;
    position: absolute;
    top: -12px;
    left: 15px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
  }
  .textarea-line-box {
    width: 100%;
    height: 180px;
    margin-top: 24px;
    display: flex;
  }
  .textarea-box {
    width: 500px;
    height: 178px;
    background: #ffffff;
    border: 2px solid #b2b2b2;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
  }
  .textarea-box span {
    height: 24px;
    line-height: 24px;
    background: #fff;
    padding: 0 5px;
    position: absolute;
    top: -12px;
    left: 15px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #51abff;
  }
  .table-line {
    margin-top: 24px;
    width: 500px;
    height: 450px;
  }
  .table-line /deep/ .el-input__inner {
    border: 1px solid transparent;
    padding: 0;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #c9cfda;
  }
  .number-viewing {
    position: relative;
  }
  .table-line /deep/ .caret-wrapper {
    position: absolute;
    top: -4px;
    right: 0;
  }
  .table-line .empty {
    height: 30px;
  }
  .right-box {
    background: #fff;
    width: 550px;
    height: 650px;
    margin-top: 40px;
  }
  .main-button {
    width: 500px;
    height: 50px;
    text-align: center;
    margin-top: 20px;
  }
  .main-button button {
    cursor: pointer;
    height: 40px;
    width: 152px;
    background: #fc630c;
    border-radius: 4px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  .pagination {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
    justify-content: right;
  }
  .rowsPage {
    width: 180px;
    height: 30px;
    line-height: 30px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: #454d59;
    display: flex;
    margin-left: 10px;
  }
  .rowsPage-css {
    width: 60px;
    height: 26px;
    line-height: 26px;
    background: #ffffff;
    border: 1px solid #b0bac9;
    box-sizing: border-box;
    padding: 0 5px 0 10px;
    margin-left: 12px;
  }
  .rowsPage /deep/ .el-dropdown-link {
    width: 45px;
    height: 26px;
    display: inline-block;
    line-height: 26px;
  }
  .rowsPage /deep/ .el-icon-arrow-down {
    float: right;
    line-height: 26px;
  }

  .institution-main {
    margin-top: 15px;
    padding: 0 20px;
    box-sizing: border-box;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #686868;
  }
  .small-box-title {
    margin-top: 12px;
    padding-left: 20px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #686868;
  }
  .textarea-css-main {
    width: 99%;
    height: 99%;
    margin-left: 1px;
    margin-top: 1px;
    border-radius: 8px;
    padding: 15px 5px 5px 20px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/pages/educationalInformationReply/index.vue